// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"G7-z"};